import React from 'react';
import { motion } from 'framer-motion';
const tomi = [{
  icon: '🌿',
  title: 'Tomo 1: Fondamenti del Benessere Mediterraneo',
  desc: 'Le basi scientifiche e pratiche. Perché funziona. Come applicarlo da subito.'
}, {
  icon: '🍳',
  title: 'Tomo 2: Ricette Veloci Quotidiane',
  desc: 'Colazioni, pranzi e cene in meno di 20 minuti. Per chi ha poco tempo ma non rinuncia al gusto.'
}, {
  icon: '💪',
  title: 'Tomo 3: Ricette Proteiche Mediterranee',
  desc: 'Energia duratura, sazietà e recupero senza perdere il piacere della tavola.'
}, {
  icon: '📦',
  title: 'Tomo 4: Meal Prep Mediterraneo',
  desc: 'Organizza tutta la settimana in poche ore la domenica.'
}, {
  icon: '🌾',
  title: 'Tomo 5: Ricette Senza Zucchero e Senza Glutine',
  desc: 'Equilibrio digestivo senza rinunciare al piacere.'
}, {
  icon: '☀️',
  title: 'Tomo 6: Estate Mediterranea',
  desc: 'Ricette fresche e leggere per i mesi caldi.'
}];
export function TomiSection() {
  return <section className="py-16 px-4 bg-brand-warm" data-id="element-320">
      <div className="max-w-2xl mx-auto" data-id="element-321">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-322">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-brand-text-main mb-4" data-id="element-323">
            📚 I 6 TOMI DEL PERCORSO MEDITERRANEO
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-324">
          {tomi.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-white border border-brand-sage/20 p-5 rounded-2xl shadow-sm flex gap-4 items-start hover:border-brand-olive/50 transition-colors" data-id="element-325">
              <div className="text-3xl shrink-0 mt-1" data-id="element-326">{t.icon}</div>
              <div data-id="element-327">
                <h3 className="font-bold text-brand-olive text-lg mb-1" data-id="element-328">
                  {t.title}
                </h3>
                <p className="text-brand-text-muted text-sm sm:text-base leading-snug" data-id="element-329">
                  {t.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}